<div [ngClass]="schema?.classNames?.widget">
	<label [attr.for]="id" [ngClass]="schema?.classNames?.title">{{ title }}</label>
	<g-select
		[ngClass]="schema?.classNames?.input || 'form-control form-control-primary'"
		[attr.id]="id"
		[attr.name]="name"
		[attr.readonly]="schema.readOnly ? true : null"
		[disabled]="schema.readOnly"
		[formControl]="control"
		[placeholder]="placeholder"
		[items]="items"
		[selectedLabelFormatter]="selectedLabelFormatter"
	/>
</div>
<div class="validation-error">{{ control.errors | sfValidationError: schema : control.value }}</div>
